import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description WebDesign icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { WebDesign } from '@sravni/design-system-icons'
 *
 * <WebDesign />
 * ```
 */
var WebDesign = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "WebDesign", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.667 17.5H3.333a.834.834 0 0 1-.833-.833v-3.334c0-.46.373-.833.833-.833h13.334c.46 0 .833.373.833.833v3.334c0 .46-.373.833-.833.833ZM16.667 9.167h-5a.834.834 0 0 1-.834-.834v-5c0-.46.374-.833.834-.833h5c.46 0 .833.373.833.833v5c0 .46-.373.834-.833.834ZM7.5 2.5h-5M7.5 5.833h-5M7.5 9.167h-5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { WebDesign };
//# sourceMappingURL=WebDesign.js.map
